import { render, staticRenderFns } from "./additional-travellers-combined-product-form.vue?vue&type=template&id=3026200a&scoped=true"
import script from "./additional-travellers-combined-product-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./additional-travellers-combined-product-form.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./additional-travellers-combined-product-form.vue?vue&type=style&index=0&id=3026200a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3026200a",
  null
  
)

export default component.exports